module.exports = __webpack_public_path__ + "static/media/bnb_lay.8f883e29.svg";